export function notifyCoworkFilesUploaded(scope: {
  companyID: string
  projectID: string
  periodID: string | null
}): void {
  window.dispatchEvent(
    new CustomEvent("cowork-files-uploaded", {
      detail: Object.freeze({
        companyID: scope.companyID,
        projectID: scope.projectID,
        periodID: scope.periodID,
      }),
    }),
  )
}

export function shouldRefreshCoworkFiles(
  detail: unknown,
  context:
    | { company_id: string; project_id: string; period_id?: string | null; workflow_id?: string | null }
    | undefined,
  remoteSessionID: string,
): boolean {
  if (!detail || typeof detail !== "object" || Array.isArray(detail)) return false
  const value = detail as Record<string, unknown>
  // Partial scope metadata must never fall back to a matching legacy session ID.
  if (!("companyID" in value) && !("projectID" in value) && !("periodID" in value)) {
    return (
      Object.keys(value).length === 1 &&
      typeof value.sessionID === "string" &&
      value.sessionID.trim().length > 0 &&
      value.sessionID === remoteSessionID
    )
  }
  if (
    typeof value.companyID !== "string" ||
    !value.companyID.trim() ||
    typeof value.projectID !== "string" ||
    !value.projectID.trim() ||
    !(value.periodID === null || (typeof value.periodID === "string" && value.periodID.trim().length > 0))
  ) {
    return false
  }
  if (!context || value.companyID !== context.company_id || value.projectID !== context.project_id) return false
  const periodID = context.period_id ?? context.workflow_id
  return periodID == null || value.periodID === periodID
}
